import { client } from 'shared';

export interface CoveredShift {
    id: number;
    shift_day: string;
    subs_to_cover: number;
    subs_remaining: number;
    description: string | null;
    sub_pool_name: string;
    address: number;
    business_location_name: string | null;
}

export function fetchCoveredShifts(start: string, end: string, addressIds: number[]): Promise<CoveredShift[]> {
    const params = new URLSearchParams({ start, end });
    addressIds.forEach((addressId) => params.append('address', String(addressId)));
    return client(`api/business-covered-shifts/?${params.toString()}`);
}
